import { render, staticRenderFns } from "./TalentCenterAccount.vue?vue&type=template&id=6538288b&scoped=true&"
import script from "./TalentCenterAccount.vue?vue&type=script&lang=js&"
export * from "./TalentCenterAccount.vue?vue&type=script&lang=js&"
import style0 from "./TalentCenterAccount.vue?vue&type=style&index=0&id=6538288b&prod&lang=css&"
import style1 from "./TalentCenterAccount.vue?vue&type=style&index=1&id=6538288b&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6538288b",
  null
  
)

export default component.exports